import script from "./DefaultSign.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultSign.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultSign.vue?vue&type=style&index=0&id=235ab626&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-235ab626"]])

export default __exports__